import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Layout } from '../components/Layout';
import { DataTable } from '../components/DataTable';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { format } from 'date-fns';

const API_URL = process.env.REACT_APP_API_URL || 'https://tecteach-server.vercel.app/api/v1';

const Projects: React.FC = () => {
  const { admin } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/users/get-all-projects?whiteLabelClientId=${admin?.whiteLabelClientId}`
        );
        setProjects(response.data);
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setLoading(false);
      }
    };

    if (admin?.whiteLabelClientId) {
      fetchProjects();
    }
  }, [admin]);

  const columns = [
    { id: 'projectTitle', label: 'Project Title' },
    { id: 'userEmail', label: 'User Email' },
    {
      id: 'submissionDate',
      label: 'Submission Date',
      format: (value: string) => format(new Date(value), 'MMM dd, yyyy'),
    },
  ];

  return (
    <Layout>
      <Box>
        <Typography variant="h4" fontWeight={700} color="#142060" gutterBottom>
          Projects
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          UAUP Course Projects
        </Typography>

        <DataTable columns={columns} data={projects} loading={loading} />
      </Box>
    </Layout>
  );
};

export default Projects;
